import { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import Loader from '../../../common/Loader';
import { t } from "i18next";
import { getValueFromResource } from "../../../common/timeLiveFunction";
import { useAppDispatch } from "../../../app/hooks";

export const AccountZapierOnline = () => {
   const dispatch = useAppDispatch();
   const [isLoading, setIsLoading] = useState(true);
   useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://zapier.com/apps/embed/widget.js?services=timelive&limit=10&html_id=Zaps";
      script.async = true;
      const zapsElement = document.getElementById("Zaps");
      if (zapsElement) {
         zapsElement.appendChild(script);
         script.onload = () => {
            setIsLoading(false);
         };
      }
      return () => {
         if (zapsElement) {
            zapsElement.removeChild(script);
         }
      };
   }, []);

   return (
      <>
         {isLoading && <Loader />}
         <div className="card card-custom admin-card">
            <div className="zapierCenter">
               <img src={toAbsoluteUrl('/media/images/ZapierIntegeration.png')} alt="Zapier Integration"
                  style={{
                     height: 480, width: 1000, marginTop: 12, marginBottom: 12
                  }} />
            </div>
            <h4 className="text-center fw-bold" style={{ color: '#181c32' }}>
               {/* {t('Connect TimeLive to 1000 plus Zapier apps for your ease without a line of code')} */}
               {getValueFromResource('Connect TimeLive to 1000 plus Zapier apps for your ease without a line of code',dispatch, t)}

               </h4>
            <div className="mt-2 mb-4 zapierCenter">
               <p>
                  <a href="https://zapier.com/apps/timelive/integrations" target="_blank">
                     {/* {"TimeLive Integration"} */}
                     {getValueFromResource('TimeLive Integration',dispatch, t)}

                  </a>
                  <a>
                     {/* {t('At Zapier, automate your daily routine work by transferring your Time Live data to other Apps or from other Apps to TimeLive.')} */}
                     {getValueFromResource('At Zapier, automate your daily routine work by transferring your Time Live data to other Apps or from other Apps to TimeLive.',dispatch, t)}

                  </a>
                  <a><br />
                     {/* {t('Once you create a Zap,')} */}
                     {getValueFromResource('Once you create a Zap,',dispatch, t)}

                  </a>
                  <a>
                     {/* {t('Zapier will do things on your behalf.')} */}
                     {getValueFromResource('Zapier will do things on your behalf.',dispatch, t)}

                  </a>
               </p>
            </div>
            <div className="row">
               <div className="col-md-2"></div>
               <div className="col-md-8 col-md-offset-2">
                  <div id="Zaps" className="text-center">
                  </div>
               </div>
               <div className="col-md-2"></div>
            </div>
         </div>
      </>
   )
}